import actionTypes from './ActionTypes';
import apiSettings from '../../config/api';
import request from '../../utils/request';
import {setLocalStorage} from '../../utils/storage';

const checkCartStorage = (resData, storage) => {
  if (storage && storage.length) {
    for (let i = 0; i < storage.length; i++) {
      let isDeleteFromStorage = true;
      for (let k = 0; k < resData.length; k++) {
        if (resData[k].id === storage[i].id) {
          isDeleteFromStorage = false;
        }
      }
      if (isDeleteFromStorage)
        storage.splice(i, 1);
    }
    setLocalStorage('cart', storage);
  }
  return storage;
};

// [{"id":5,"persons":15,"date":"2018-08-10","timeSlotId":68,"guide":true}]

const getCartTours = (idArr, cb) => {
  return (dispatch, getState) => {
    const url = apiSettings.endpoints.gengetToursForCart();
    const stateCartList = getState().cart.list;
    let toursId = [];
    if (idArr) {
      toursId = idArr;
    } else if (stateCartList && stateCartList.length > 0) {
      for (let i = 0; i < stateCartList.length; i++) {
        toursId.push(stateCartList[i].id)
      }
    }
    request
      .post(url, {toursId}, dispatch, actionTypes.GET_CART_TOURS)
      .then((res) => {
        if (typeof cb === 'function')
          cb(res.data.tours);
        else {
          // Check Storage
          dispatch({type: actionTypes.GET_CART_TOURS.fulfilled, data: res.data.tours, list: checkCartStorage(res.data.tours, stateCartList)});
        }
      })
  }
};

const addToCart = (tour, cityId) => {
  return (dispatch, getState) => {
    const list = [...getState().cart.list];
    if (list.length !== 0)
      dispatch(getCartTours(null, (t) => {
        if (t[0] && t[0].cityId === cityId) {
          list.push(tour);
          setLocalStorage('cart', list);
          dispatch({type: actionTypes.CHANGE_CART, data: list});
        } else {
          dispatch({type: actionTypes.CHANGE_CART_ERROR, data: 'You can not add tours from different cities'});
          setTimeout(() => {
            dispatch({type: actionTypes.CHANGE_CART_ERROR, data: ''});
          }, 7000);
        }
      }));
    else {
      list.push(tour);
      setLocalStorage('cart', list);
      dispatch({type: actionTypes.CHANGE_CART, data: list});
    }
  }
};

const deleteFromCart = (tourId, checkTourList) => {
  return (dispatch, getState) => {
    const list = [...getState().cart.list];
    for (let i = 0; i < list.length; i++) {
      if (list[i].id === tourId) {
        list.splice(i, 1);
        break;
      }
    }
    setLocalStorage('cart', list || []);
    dispatch({type: actionTypes.CHANGE_CART, data: list || []});

    if (checkTourList) {
      const tourList = [...getState().cart.toursList];
      for (let i = 0; i < tourList.length; i++) {
        if (tourList[i].id === tourId) {
          tourList.splice(i, 1);
          break;
        }
      }
      dispatch({type: actionTypes.GET_CART_TOURS.fulfilled, data: tourList || [], list: list || []});
    }
  }
};

const changeTourData = (data) => {
  return (dispatch, getState) => {
    const list = [...getState().cart.list];
    for (let i = 0; i < list.length; i++) {
      if (list[i].id === data.id) {
        list[i] = data;
        break;
      }
    }
    setLocalStorage('cart', list);
    dispatch({type: actionTypes.CHANGE_CART, data: list});
  }
};

const setMetingPlace = (data) => {
  return dispatch => {
    setLocalStorage('cart_meting_place', data);
    dispatch({type: actionTypes.SET_METING_PLACE, data})
  }
};

const cleanCart = () => {
  return dispatch => {
    setLocalStorage('cart_meting_place', '');
    setLocalStorage('cart', []);
    dispatch({type: actionTypes.CLEAR_CART})
  }
};

export {
  addToCart,
  deleteFromCart,
  getCartTours,
  changeTourData,
  setMetingPlace,
  cleanCart,
}


// WEBPACK FOOTER //
// ./src/app/containers/Cart/Actions.js